var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto px-4 sm:px-6 lg:px-8",class:_vm.maxWidth},[_c('div',{class:{ 'py-4 mb-6': _vm.padding }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }